module.exports = __webpack_public_path__ + "img/avatar-58.01e82151.png";